import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { CAPTCHA_TYPE, GOOGLE_CAPTCHA_KEY } from 'config';

import { CaptchaType } from 'types/captcha';
import { ICaptchaProviderProps } from './CaptchaProvider.types';

const CaptchaProvider = ({ children }: ICaptchaProviderProps): React.ReactElement => {
  if (CAPTCHA_TYPE === CaptchaType.GOOGLE) {
    return <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_CAPTCHA_KEY}>{children}</GoogleReCaptchaProvider>;
  }

  return <>{children}</>;
};

export default CaptchaProvider;
